import { BiMailSend } from 'react-icons/bi';
import { BsPhone } from 'react-icons/bs';
import { RiComputerLine } from 'react-icons/ri';
import { LoadingSend as LoadingSendStyled } from '../../styled';

const LoadingSend = () => {
    return (
        <LoadingSendStyled>
            <span className='area--pc--'>
                <RiComputerLine className='icon--' />
            </span>
            <span className='area--msg--'>
                <BiMailSend className='icon-- icon--animation' />
            </span>
            <span className='area--cel--'>
                <BsPhone className='icon--' />
            </span>
        </LoadingSendStyled>
    );
};

export default LoadingSend;